import request from '@/service/index'
import { ItaskOrderSearchItem } from '@/@types/global'
import qs from 'qs'

// 获取号码筛开通列表
export const getTelList = (params: ItaskOrderSearchItem) => {
  return request({
    url: '/taskOrder/getList',
    method: 'GET',
    params
  })
}

// 上传文件接口
export const uploadFile = (data: any) => {
  return request({
    url: '/taskOrder/checkFile',
    method: 'POST',
    data
  })
}

// 提交新建筛选接口
export const handleSubmitFilter = (data: any) => {
  return request({
    url: '/taskOrder/addTask',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 编辑--上传文件接口
export const uploadFileInEdit = (data: any) => {
  return request({
    url: '/taskOrder/uploadResultFile',
    method: 'POST',
    data
  })
}

// 编辑--提交接口
export const handleEditFilter = (data: any) => {
  return request({
    url: '/taskOrder/editTask',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 上传筛选，请求获取数据接口
export const getExtData = (url: string) => {
  return request({
    url,
    method: 'GET'
  })
}

export const submitFilterTask = (data: any) => {
  return request({
    url: '/taskOrder/addAgentTask',
    method: 'POST',
    data: qs.stringify(data)
  })
}

export const bathDownResult = (data: any) => {
  let form = document.createElement('form');
  form.method = 'post';
  form.action = '/api/taskOrder/bathDown';
  let formHtml = '';
  if (data.length > 0) {
    data.forEach((item: any) => {
      formHtml += `<input type="hidden" name="taskGuids" value="${item}" />`;
    })
    form.innerHTML = formHtml;
  }
  document.body.insertAdjacentElement('beforeend', form);
  //target也可以是本页面的iframe的name
  form.target = '_blank';
  form.submit();
}
